import { makeAutoObservable, runInAction } from 'mobx';

import type { Main } from '@app/store';

import type { CandidateProfile } from '../candidate-profile.type';

export class CandidateContractStore {
  private mainStore: Main;
  candidateData?: CandidateProfile;

  constructor(mainStore: Main) {
    this.mainStore = mainStore;
    makeAutoObservable(this);
  }

  setCandidateData = (candidateData: CandidateProfile) => {
    this.candidateData = {
      ...this.candidateData,
      ...candidateData,
    };
  };

  reset() {
    runInAction(() => {
      this.candidateData = undefined;
    });
  }
}
